'use strict';

module.exports = {
  HTML_END: 'HTML_END',
  OPEN_TAG_START: '<',
  TAG_END: '>',
  SELF_CLOSING: '/>',
  CLOSING_TAG_START: '</',
  SPACE: ' '
};


//////////////////
// WEBPACK FOOTER
// ./~/@wix/neat-html-parser/build/tokens.js
// module id = 91
// module chunks = 0 1